import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    const honeypot = (form.elements.namedItem('website_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setStatus('success');
      setEmail('');
      setTimeout(() => setStatus('idle'), 3000);
      return;
    }

    setStatus('submitting');
    setErrorMsg('');

    try {
      const formData = new FormData(form);
      formData.delete('website_alt');

      const res = await fetch('https://readdy.ai/api/form/d9u3uml3pcjqs2fcsli0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let parsed;
      try { parsed = JSON.parse(text); } catch { parsed = null; }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
        setTimeout(() => setStatus('idle'), 3000);
      } else {
        const msg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后重试';
        setErrorMsg(msg);
        if (msg.includes('spam') || msg.includes('form data is spam')) {
          setStatus('success');
          setEmail('');
          setTimeout(() => setStatus('idle'), 3000);
        } else {
          setStatus('error');
        }
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请稍后重试');
    }
  };

  return (
    <section className="py-16 md:py-20 bg-primary-600">
      <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
        <div className="w-14 h-14 mx-auto mb-6 rounded-full bg-white/20 flex items-center justify-center">
          <i className="ri-mail-send-line text-2xl text-white"></i>
        </div>
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-white mb-3">
          订阅我们的通讯
        </h2>
        <p className="text-white/80 text-sm md:text-base mb-8">
          获取最新的性健康知识、研究进展和实用指南，直接发送到你的邮箱。
        </p>

        <form
          onSubmit={handleSubmit}
          data-readdy-form
          className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
        >
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="form-anti-spam"
          />
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入你的邮箱地址"
            required
            className="flex-1 px-5 py-3 rounded-full bg-white text-foreground-900 text-sm placeholder:text-foreground-400 border-0 focus:outline-none focus:ring-2 focus:ring-white/50"
          />
          <button
            type="submit"
            disabled={status === 'submitting'}
            className="px-6 py-3 bg-accent-500 hover:bg-accent-600 text-white rounded-full font-medium text-sm transition-all duration-300 disabled:opacity-50 whitespace-nowrap cursor-pointer"
          >
            {status === 'submitting' ? '订阅中...' : '订阅'}
          </button>
        </form>

        {status === 'success' && (
          <p className="mt-4 text-sm text-white/90">感谢订阅！我们很快就会给你发送最新内容。</p>
        )}
        {status === 'error' && (
          <p className="mt-4 text-sm text-accent-200">{errorMsg}</p>
        )}
      </div>
    </section>
  );
}